





import { Component, Vue, Watch } from 'vue-property-decorator';
import Chart from 'chart.js';

@Component({
  props: ['periodResources', 'machineId', 'currency'],
})
export default class PieChart extends Vue {
  periods: any = [];
  chartLegend: any = [];
  chartData: any = [];
  pieId = 'pieChart-' + Math.random() + '-' + new Date().getTime();
  chartHandle: any = null;

  @Watch('$props.periodResources', { immediate: true, deep: true })
  onInitialValueChange(value: any) {
    if (value) {
      this.periods = value;
      if (this.chartHandle) {
        this.chartHandle.destroy();
        this.chartHandle = null;
      }
      setTimeout(() => {
        this.initChart();
      }, 500);
    }
  }
  initChart() {
    const self = this;
    let chartDataTmp: any = {};
    this.chartLegend = [];
    this.chartData = [];
    this.periods = this.$props.periodResources;
    for (let k in this.periods) {
      for (let z in this.periods[k].resources) {
        if (this.periods[k].resources[z].cost) {
          if (chartDataTmp[this.periods[k].resources[z].name]) {
            chartDataTmp[this.periods[k].resources[z].name] += this.periods[k].resources[z].cost * 0.00001;
          } else {
            chartDataTmp[this.periods[k].resources[z].name] = this.periods[k].resources[z].cost * 0.00001;
          }
        }
      }
    }
    for (let label in chartDataTmp) {
      this.chartLegend.push(this.getDisplayName(label));
      this.chartData.push(chartDataTmp[label].toFixed(4));
    }
    this.chartHandle = new Chart(this.pieId, {
      type: 'pie',
      data: {
        labels: this.chartLegend,
        datasets: [
          {
            backgroundColor: ['#009CF2', '#7eccf7', '#cbeafc', '#5ca8ff'],
            borderWidth: 0,
            data: this.chartData,
          },
        ],
      },
      options: {
        tooltips: {
          callbacks: {
            label: function(tooltipItem: any, data: any) {
              return (
                self.chartLegend[tooltipItem.index] +
                ': ' +
                (self.$props.currency !== 'PLN' ? self.fixCurrency(self.$props.currency) : '') +
                data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index] +
                (self.$props.currency === 'PLN' ? self.fixCurrency(self.$props.currency) : '')
              );
            },
          },
        },
      },
    });
  }
  fixCurrency(currency: string) {
    if (currency === 'PLN') {
      return 'zł';
    }
    if (currency === 'USD') {
      return '$';
    }
    if (currency === 'EUR') {
      return '€';
    }
    return currency;
  }
  getDisplayName(name: string) {
    const formattedNames: any = {
      backup_storage: this.$t('backupStorage'),
      storage_hdd: this.$t('diskHDD'),
      storage_ssd: this.$t('diskSSD'),
      win10: this.$t('win10'),
      ram: 'RAM',
      cpu: 'CPU',
    };
    return formattedNames[name] ? formattedNames[name] : name;
  }
}
